import qs, { ParsedQuery } from 'query-string'

export default (): ParsedQuery<string> => {
  return qs.parse(window.location.search, {
    arrayFormat: 'bracket',
  })
}
